module.exports = __webpack_public_path__ + "img/0.da3a4889.png";